import { STATE__grid2d } from '../STATE__grid2d';

export function FN_SLICE__grid2d_recreate(state: STATE__grid2d) {
  //need refresh user_tasks_map to rerender components
  state.grids2d_map = new Map(state.grids2d_map);
}
